import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "primereact/checkbox";
import { createSortByAttr } from "../../../../components/Utils";

const getColumn = (items, number) => {
  const col = [];
  let size = Math.floor(items.length / 3);
  if (items.length - size * 3 > 1) {
    size++;
  }
  let startIndex = 0;
  let endIndex = size - 1;
  if (number === 1 || number === 2 || number === 3) {
    startIndex = (number - 1) * size;
    endIndex = startIndex + size - 1;
    if (number === 3) {
      endIndex = items.length - 1;
    }
  }
  items.forEach((item, index) => {
    if (index >= startIndex && index <= endIndex) {
      col.push(item);
    }
  });
  return col;
};

function TechKeyForm({
  forwardedRef,
  className = "",
  model = [],
  techKeys = [],
  disabled: _disabled,
  readOnly,
}) {
  const disabled = readOnly || _disabled;
  const [state, setState] = React.useState({
    model: model ? model.map((item) => item.id) : [],
  });

  const validate = React.useCallback(() => {
    const { model } = state;
    return model.map((id) => {
      const item = techKeys.find((item) => item.id === id);
      return { id, number: item ? item.number : null };
    });
  }, [state, techKeys]);

  const getModel = React.useCallback(
    (noValidate) => validate(noValidate),
    [validate],
  );
  React.useImperativeHandle(forwardedRef, () => ({ getModel }));

  const onCheckboxChange = React.useCallback(
    (event) => {
      let newModel = [...state.model];
      if (event.checked) newModel.push(event.value);
      else newModel.splice(newModel.indexOf(event.value), 1);
      setState({ model: newModel });
    },
    [state],
  );

  const createCheckbox = React.useCallback(
    (prefix) => (item, index) => (
      <div
        key={index}
        className="p-col-12"
        id={item.number.split(" ").join("")}
      >
        <Checkbox
          id={`checkbox-${prefix}${index}`}
          inputId={`${prefix}${index}`}
          data-test-id={`${prefix}${index}`}
          value={item.id}
          onChange={onCheckboxChange}
          checked={state.model.includes(item.id)}
          disabled={disabled}
        ></Checkbox>
        <label htmlFor={`${prefix}${index}`} className="p-checkbox-label">
          {item.number}
        </label>
      </div>
    ),
    [state, onCheckboxChange, disabled],
  );

  const sortedTechKeys = techKeys.sort(createSortByAttr("number"));
  const col1 = getColumn(sortedTechKeys, 1).map(createCheckbox("cb1-"));
  const col2 = getColumn(sortedTechKeys, 2).map(createCheckbox("cb2-"));
  const col3 = getColumn(sortedTechKeys, 3).map(createCheckbox("cb3-"));
  return (
    <div className={className}>
      <div className="neg-margin-lr">
        <div className="w3-row">
          <div className="w3-col s4 pad-lr">{col1}</div>
          <div className="w3-col s4 pad-lr">{col2}</div>
          <div className="w3-col s4 pad-lr">{col3}</div>
        </div>
      </div>
    </div>
  );
}

TechKeyForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.array,
  techKeys: PropTypes.array,
  minimal: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default React.forwardRef((props, ref) => (
  <TechKeyForm {...props} forwardedRef={ref} />
));
